import React from 'react';
import {Handle, HandleType} from 'reactflow';

import HandleDot from 'ui-library/reactflow/handles/HandleDot';
import {defaultHandleProps} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeHandleUtils';
import {HandleInteractionProps} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeTypes';

/**
 * Default node handle ID generator
 */
export function defaultNodeHandleIdGenerator(nodeId: string, handleType: HandleType): string {
  return `${nodeId}-${handleType}`;
}

/**
 * Handles used to draw edges between two nodes.
 */
export function SimpleBenchlingNodeHandle(props: {
  nodeId: string;
  handleType: HandleType;
  nodeHeaderHandleIdGenerator?: (nodeId: string, handleType: HandleType) => string | null;
  additionalProps: HandleInteractionProps;
}): JSX.Element | null {
  const handleId = props.nodeHeaderHandleIdGenerator
    ? props.nodeHeaderHandleIdGenerator(props.nodeId, props.handleType)
    : defaultNodeHandleIdGenerator(props.nodeId, props.handleType);
  return handleId ? (
    <Handle {...defaultHandleProps(props.handleType)} id={handleId} {...props.additionalProps}>
      <HandleDot />
    </Handle>
  ) : null;
}
